import React from 'react'
import { Row } from '@ztechapps/webui.data-tools'
import { formatMoney } from '@ztechapps/common.utils'

export const ListRow = (props) => {
  const { product, quantity, price, net } = props
  return (
    <Row {...props}>
      <td>{product?.code}</td>
      <td>{quantity}</td>
      <td>{formatMoney(price)}</td>
      <td>{formatMoney(net)}</td>
    </Row>
  )
}
